import { gql } from '@apollo/client';

export const CREATE_PATIENT = gql`
  mutation CreatePatient($record: CreatePatientInput!) {
    user {
      patientUser {
        createPatient(record: $record) {
          ok
          error {
            message
            code
            description
          }
          resultId
          result {
            id
            ins
            cpf
            activeIns {
              value
              type
              oid
            }
            identityReliabilityStatus
            name {
              firstName
              lastName
            }
            email
            phone
            gender
            birthDate
            birthPlace {
              country
              city
              address
              zipcode
            }
            birthPlaceInseeCode
            preferredLanguages
          }
        }
      }
    }
  }
`;
